<template>
  <div>
    <template v-if="(parentFilter.tahun && parentFilter.kolok)">
      <b-overlay :show="isLoadDetail" variant="light" opacity="0.85" blur="2px" rounded="sm">
        <div class="card mb-1">
          <div class="card-header d-block border-bottom">
            <div class="text-center">
              <h4 class="font-weight-bolder text-uppercase text-primary">SK TIM INVENTARISASI PERALATAN DAN
                MESIN
                <br /> PADA {{ headerSkTim }}
                <br /> Tahun {{ parentFilter.tahun }}
              </h4>
            </div>
          </div>
          <div class="card-body pt-1">
            <div class="row py-1 px-0">
              <div class="col-12">
                <div class="d-flex flex-row justify-content-between overflow-auto">
                  <div class="mr-2" style="width: max-content;">
                    <div style="margin-bottom: 5px;">
                      <span class="font-weight-bolder text-uppercase">Nama PD/UKPD/UPB</span>
                    </div>
                    <div>
                      <span class="font-size-lg">{{ formDatas.nalok || '-' }}</span>
                    </div>
                  </div>
                  <div class="text-center border rounded border-light bg-light"
                    style="width: 200px; height: 60px; position: relative;">
                    <div
                      style="position: absolute; top: 20px; left: 50%; transform: translate(-50%, -50%); width: max-content;">
                      <span class="font-weight-bold text-uppercase">Status</span>
                    </div>
                    <div class="overflow-auto" style="margin: 30px 5px 10px 5px;">
                      <b-badge variant="light-primary">
                        {{ formDatas.nama_status || formDatas.status || '-' }}
                      </b-badge>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="(['sk-tim-draft', 'sk-tim-tolak-p3b', 'sk-tim-tolak-ka'].includes(formDatas.status) || formDatas.status === null) && $can('Update', 'b-sk-tim')"
              class="row py-1 px-0 mx-0 d-flex justify-content-start">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="changeStateEvent('update')">
                <feather-icon icon="EditIcon" class="mr-50" />
                <span class="align-middle">Update SK TIM</span>
              </b-button>
            </div>
            <hr />
            <div v-if="canUpload" class="card text-center bg-light-danger">
              <div class="card-body p-1">
                <div class="font-weight-bold">
                  Batas Waktu Upload Dokumen SK TIM
                </div>
                <div>({{ targetDate }})</div>
                <div class="text-center d-flex justify-content-center" style="gap: 15px">
                  <div><span class="font-large-2 mr-50">{{ days }}</span><span>Hari</span>
                  </div>
                  <div><span class="font-large-2 mr-50">{{ hours }}</span><span>Jam</span>
                  </div>
                  <div><span class="font-large-2 mr-50">{{ minutes }}</span><span>Menit</span>
                  </div>
                  <div><span class="font-large-2 mr-50">{{ seconds }}</span><span>Detik</span>
                  </div>
                </div>
              </div>
            </div>
            <template v-for="(item, i) in formDatas.data_struktural" :keys="i">
              <div class="border px-1 border-1 py-1 px-0 mx-0 mb-1 rounded bg-light-secondary">
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h5 class="font-weight-bold text-uppercase">
                          <span v-if="item.ref_jabatan_sk_tim_kode == 'ketua'">Ketua
                            ({{ lebelField('ketua') }})</span>
                          <span v-else-if="item.ref_jabatan_sk_tim_kode == 'wakil'">Wakil Ketua
                            (Pejabat
                            Eselon
                            II/III)</span>
                          <span v-else-if="item.ref_jabatan_sk_tim_kode == 'sekretaris'">Sekretaris
                            ({{ lebelField('sekretaris') }})</span>
                          <span v-else-if="item.ref_jabatan_sk_tim_kode == 'sekretariat'">Sekretariat
                            ({{ lebelField('sekretariat') }})</span>
                          <span v-else>{{ item.ref_jabatan_sk_tim_kode }}</span>
                          <span v-if="item.is_plt == 'iya'" class="text-warning ml-50">(PLT)</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NRK</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nrk || '-' }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NAMA</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nama || '-' }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NIP</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nip || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <hr class="my-2" />
            <div class="row mb-1">
              <div class="col-12">
                <div>
                  <h5 class="font-weight-bold text-uppercase text-muted">Daftar Anggota ({{
                    lebelField('anggota') }})
                  </h5>
                </div>
                <b-alert show variant="warning">
                  <div class="alert-body">
                    <div class="d-flex flex-row align-items-center" style="gap: 5px;">
                      <div class="icon-wrapper">
                        <feather-icon icon="InfoIcon" class="mr-50 mt-25" />
                      </div>
                      <div>
                        <span>Maksimal Anggota 40 Orang</span>
                      </div>
                    </div>
                  </div>
                </b-alert>
              </div>
            </div>
            <template v-for="(item, i) in formDatas.data_anggota" :keys="i">
              <div class="border px-1 border-1 py-1 px-0 mx-0 mb-1 rounded bg-light-secondary">
                <div class="row mb-1">
                  <div class="col-12">
                    <div>
                      <h5 class="font-weight-bold text-uppercase">Anggota {{ i + 1 }}</h5>
                    </div>
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NRK</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nrk || '-' }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NAMA</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nama || '-' }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NIP</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nip || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <hr />
            <div class="row mb-2" v-if="['sk-tim-submit'].includes(formDatas.status) && $can('Validasi-P3B', 'b-sk-tim')">
              <div class="col-12 d-flex justify-content-center">
                <div class="text-center bg-light-primary p-2 rounded" style="width: 300px;">
                  <div class="font-weight-bolder mb-2">Validasi SK TIM Oleh P3B</div>
                  <div class="text-center">
                    <b-button v-if="!loadingp3bValidasi" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                      size="md" @click="openp3bValidasiDialog">
                      <feather-icon icon="SendIcon" class="mr-50" />
                      <span class="align-middle">Validasi P3B</span>
                    </b-button>
                    <b-button v-else variant="primary" disabled>
                      <b-spinner small />
                      Loading...
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2"
              v-if="['sk-tim-validasi-p3b'].includes(formDatas.status) && $can('Validasi-Kepala', 'b-sk-tim')">
              <div class="col-12 d-flex justify-content-center">
                <div class="text-center bg-light-primary p-2 rounded" style="width: 300px;">
                  <div class="font-weight-bolder mb-2">Validasi SK TIM Oleh Kepala</div>
                  <div class="text-center">
                    <b-button v-if="!loadingKepalaValidasi" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                      size="md" @click="openKepalaValidasiDialog">
                      <feather-icon icon="SendIcon" class="mr-50" />
                      <span class="align-middle">Validasi Kepala</span>
                    </b-button>
                    <b-button v-else variant="primary" disabled>
                      <b-spinner small />
                      Loading...
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="formDatas.urutan >= 4">
              <div class="row mb-2">
                <div class="col-12">
                  <div class="text-center p-2">
                    <div class="font-weight-bolder">
                      <h3 class="font-weight-bold text-uppercase text-muted">Dokumen SK TIM
                      </h3>
                    </div>
                    <div class="mt-2" v-if="canUpload">
                      <div class="mb-1">
                        <span>Silahkan cetak dokumen SK TIM</span>
                        <div>
                          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" size="sm"
                            @click="cetakDokumenSkTim">
                            <feather-icon icon="SendIcon" class="mr-50" />
                            <span class="align-middle">Cetak Dokumen</span>
                          </b-button>
                        </div>
                      </div>
                      <div class="mb-1">
                        <span>Untuk menyelesaikan tahapan ini, pengurus barang harus mengupload SK
                          TIM yang
                          telah di tanda tangani oleh Kepala PD/UKPD.</span>
                        <div v-if="$can('Upload-Dokumen', 'b-sk-tim')">
                          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-danger" size="sm"
                            @click="openUploadDokumenSkTimDialog">
                            <feather-icon icon="SendIcon" class="mr-50" />
                            <span class="align-middle">Upload Dokumen SK TIM</span>
                          </b-button>
                        </div>
                      </div>

                    </div>
                    <div v-if="!canUpload && formDatas.file_sk_tim == null">
                      <span>Batas waktu upload dokumen SK TIM telah melewati tengat waktu.</span>
                      <div>({{ targetDate }})</div>
                    </div>
                    <div v-else-if="formDatas.file_sk_tim">
                      <div class="bg-light-secondary rounded p-2 mt-2">
                        Dokumen telah diupload pada {{ parserValue('dateTime',
                          formDatas.tgl_upload_dokumen) || '-' }}
                        <div>
                          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" size="sm"
                            @click="downloadFileSkTim(formDatas.file_sk_tim)">
                            <feather-icon icon="SendIcon" class="mr-50" />
                            <span class="align-middle">Download File Dokumen SK TIM</span>
                          </b-button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <template v-if="(parentFilter.tahun && parentFilter.kolok > 0) && formDatas.urutan >= 1">
          <div v-for="(item, i) in formDatas.workflow" :key="i" class="card mb-1">
            <div class="card-header border-bottom">
              <h4 v-if="item.status_type == 'register-ajukan-pb'" class="font-weight-bold text-uppercase">
                Pengajuan
              </h4>
              <h4 v-else-if="item.status_type == 'sk-tim-validasi-p3b'" class="font-weight-bold text-uppercase">
                Validasi P3B
              </h4>
              <h4 v-else-if="item.status_type == 'sk-tim-validasi-ka'" class="font-weight-bold text-uppercase">
                Validasi Kepala PD/UKPD/UPB
              </h4>
              <h4 v-else class="font-weight-bold text-uppercase">
                {{ item.status_type }}
              </h4>
            </div>
            <div class="card-body pt-1">
              <div class="row">
                <div class="col-12 col-md-4 col-lg-4" style="padding: 0 5px 0 5px;">
                  <div class="p-1">
                    <div>
                      <span class="font-weight-bolder">Divalidasi Oleh</span>
                    </div>
                    <div>
                      <span>{{ item.action_by || '-' }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4" style="padding: 0 5px 0 5px;">
                  <div class="p-1">
                    <div>
                      <span class="font-weight-bolder">Divalidasi Pada</span>
                    </div>
                    <div>
                      <span>{{ parserValue('dateTime', item.action_at) || '-' }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4" style="padding: 0 5px 0 5px;">
                  <div class="p-1">
                    <div>
                      <span class="font-weight-bolder">Status Validasi</span>
                    </div>
                    <div>
                      <span class="badge" :class="badgeActionWf(item.action)">{{
                        item.action || '-'
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12" style="padding: 0 5px 0 5px;">
                  <div class="p-1">
                    <div>
                      <span class="font-weight-bolder">Catatan Validasi</span>
                    </div>
                    <div>
                      <span>{{ item.catatan || '-' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </b-overlay>
      <b-modal centered id="modal-p3b-validasi" ref="p3bValidasiModalRef" scrollable title="Validasi P3B"
        cancel-title="Batal" ok-title="Kirim" cancel-variant="outline-secondary" @ok="confirmP3bValidasiDialog">
        <validation-observer ref="rulesValP3B">
          <b-row>
            <b-col cols="12">
              <div>
                <span>Status Persetujuan <span class="text-danger">*</span></span>
              </div>
              <validation-provider #default="{ errors }" name="Status Persetujuan" rules="required">
                <div class="d-flex flex-wrap flex-row" style="gap:20px;margin-top: 5px;">
                  <b-form-radio v-model="formDatasP3BValidasi.is_validasi" name="setuju" value="setuju">
                    Setuju
                  </b-form-radio>
                  <b-form-radio v-model="formDatasP3BValidasi.is_validasi" name="dikembalikan" value="kembalikan">
                    Dikembalikan
                  </b-form-radio>
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col v-if="formDatasP3BValidasi.is_validasi == 'kembalikan'" cols="12" class="mt-2">
              <div>
                <span class="required">Catatan Validasi <span class="text-danger">*</span></span>
              </div>
              <validation-provider #default="{ errors }" name="Catatan Validasi" rules="required">
                <b-form-textarea id="catatan-p3b" v-model="formDatasP3BValidasi.catatan"
                  placeholder="Isi Catatan Validasi" rows="3" :state="errors.length > 0 ? false : null" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </b-modal>
      <b-modal centered id="modal-kepala-validasi" ref="kepalaValidasiModalRef" scrollable
        title="Validasi Kepala PD/UKPD/UPB" cancel-title="Batal" ok-title="Kirim" cancel-variant="outline-secondary"
        @ok="confirmKepalaValidasiDialog">
        <validation-observer ref="rulesValKepala">
          <b-row>
            <b-col cols="12">
              <div>
                <span>Status Persetujuan <span class="text-danger">*</span></span>
              </div>
              <validation-provider #default="{ errors }" name="Status Persetujuan" rules="required">
                <div class="d-flex flex-wrap flex-row" style="gap:20px;margin-top: 5px;">
                  <b-form-radio v-model="formDatasKepalaValidasi.is_validasi" name="setuju" value="setuju">
                    Setuju
                  </b-form-radio>
                  <b-form-radio v-model="formDatasKepalaValidasi.is_validasi" name="dikembalikan" value="kembalikan">
                    Dikembalikan
                  </b-form-radio>
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col v-if="formDatasKepalaValidasi.is_validasi == 'kembalikan'" cols="12" class="mt-2">
              <div>
                <span class="required">Catatan Validasi <span class="text-danger">*</span></span>
              </div>
              <validation-provider #default="{ errors }" name="Catatan Validasi" rules="required">
                <b-form-textarea id="catatan-kepala" v-model="formDatasKepalaValidasi.catatan"
                  placeholder="Isi Catatan Validasi" rows="3" :state="errors.length > 0 ? false : null" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </b-modal>
      <b-modal centered id="modal-upload-dokumen-sk-tim" ref="uploadDokumenSkTimModalRef" scrollable
        :no-close-on-backdrop="true" title="Upload Dokumen SK TIM" cancel-title="Batal" ok-title="Kirim"
        cancel-variant="outline-secondary" @ok="confirmSubmitDokumenSkTim">
        <validation-observer ref="modalUploadDokumenSkTimRules">
          <div class="row">
            <div class="col-12">
              <div>
                <span class="font-weight-bold">File Dokumen SK TIM <span class="text-danger">*</span> <small
                    class="text-danger">(Maksimal 2 mb dan format PDF)</small></span>
              </div>
              <div>
                <validation-provider #default="{ errors }" name="File Dokumen SK Tim" rules="required">
                  <div class="d-flex flex-wrap flex-row" style="gap:20px;margin-top: 5px;">
                    <b-form-file v-model="uploadedFileSkTim" accept="application/pdf" @change="handleFileChange" />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <div>
                    <small class="mt-1 text-warning">*) Pastikan kembali dokumen SK TIM telah sesuai sebelum
                      melakukan upload dokumen.</small>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </validation-observer>
        <template slot="modal-footer">
          <b-button v-if="!loadingSubmitDokumenSKTim" variant="primary" @click="confirmSubmitDokumenSkTim">
            <span class="align-middle">Kirim</span>
          </b-button>
          <b-button v-else variant="primary" disabled>
            <b-spinner small />
            Loading...
          </b-button>
        </template>
      </b-modal>
    </template>
    <template v-else>
      <div class="card">
        <div class="card-header d-block border-bottom">
          <div class="text-center">
            <h4 class="font-weight-bolder text-uppercase text-primary">SK TIM INVENTARISASI PERALATAN DAN MESIN
              <br /> PADA {{ headerSkTim }}
            </h4>
          </div>
        </div>
        <div class="misc-wrapper">
          <div class="misc-inner p-2 p-sm-3">
            <div class="w-100 text-center">
              <b-alert show variant="primary" class="m-0 mb-2">
                <div class="alert-body p-3">
                  <div class="d-flex flex-row justify-content-center" style="gap: 5px;">
                    <div class="icon-wrapper">
                      <feather-icon :icon="'InfoIcon'" class="mr-50" />
                    </div>
                    <div>
                      <span class="font-weight-bold">
                        Silahkan pilih PD/UKPD/UPB untuk melihat data SK TIM.
                      </span>
                    </div>
                  </div>
                </div>
              </b-alert>
              <b-img fluid :src="imgUrl" alt="Coming soon page" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
  
<script>
import { ref, nextTick } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import skTim from "@/composables/b/skTim";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { showNotifikasi } from '@/libs/helper';
import { parserValue } from '@/libs/helper'
import { BFormFile, BModal, VBModal } from 'bootstrap-vue'
import { id as localeId } from "vee-validate/dist/locale/id";

export default {
  props: {
    fd: { type: Object, required: true },
    parentFilter: { type: Object, required: true }
  },
  setup(props, context) {

    //global variable
    const g = context.root;
    const $route = g.$route;
    const formDatas = ref({});
    const isLoadDetail = ref(false);
    const getData = () => {
      isLoadDetail.value = true;
      let params = props.parentFilter;
      if ((params.tahun && params.kolok)) {
        skTim.getDetail(g, params).then(res => {
          formDatas.value = { ...formDatas.value, ...res.data }
          generateFormDatas();
          isLoadDetail.value = false;
        }).catch(err => {
          isLoadDetail.value = false;
          console.log(err)
        });
      }
    };
    getData();

    const generateFormDatas = () => {
      let tempDataStruktural = [];
      let tempDataAnggota = [
        { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'anggota', nrk: null, nama: null, nip: null },
      ];
      /* Nanti props.fd.tipe_kolok diganti menjadi data.tipe_kolok */
      if (formDatas.value.tipe_kolok == 'skpd') {
        tempDataStruktural = [
          { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'ketua', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'wakil', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretaris', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretariat', nrk: null, nama: null, nip: null },
        ];
        const itemKetua = (formDatas.value.data_struktural) ? (formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'ketua')) : null;
        const itemWakilKetua = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'wakil') : null;
        const itemSekretaris = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretaris') : null;
        const itemSekretariat = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretariat') : null;
        if (itemKetua) tempDataStruktural[0] = itemKetua;
        if (itemWakilKetua) tempDataStruktural[1] = itemWakilKetua;
        if (itemSekretaris) tempDataStruktural[2] = itemSekretaris;
        if (itemSekretariat) tempDataStruktural[3] = itemSekretariat;
      } else if (formDatas.value.tipe_kolok == 'ukpd') {
        tempDataStruktural = [
          { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'ketua', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretaris', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretariat', nrk: null, nama: null, nip: null },
        ];
        const itemKetua = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'ketua') : null;
        const itemSekretaris = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretaris') : null;
        const itemSekretariat = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretariat') : null;
        if (itemKetua) tempDataStruktural[0] = itemKetua;
        if (itemSekretaris) tempDataStruktural[1] = itemSekretaris;
        if (itemSekretariat) tempDataStruktural[2] = itemSekretariat;
      } else if (formDatas.value.tipe_kolok == 'upb') {
        tempDataStruktural = [
          { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'ketua', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretaris', nrk: null, nama: null, nip: null },
        ];
        const itemKetua = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'ketua') : null;
        const itemSekretaris = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretaris') : null;
        if (itemKetua) tempDataStruktural[0] = itemKetua;
        if (itemSekretaris) tempDataStruktural[1] = itemSekretaris;
      }
      /* jika data anggota ga kosong */
      if (formDatas.value.data_anggota && formDatas.value.data_anggota.length > 0) tempDataAnggota = formDatas.value.data_anggota;
      formDatas.value.data_struktural = tempDataStruktural;
      formDatas.value.data_anggota = tempDataAnggota;
    }
    /* On Mounted */
    /* ------------------------------- */


    /* Validasi */
    const formDatasP3BValidasi = ref({
      username: g.$cookies.get("username"),
      is_validasi: null,
      catatan: null
    });
    const p3bValidasiModalRef = ref(null);
    const openp3bValidasiDialog = () => {
      p3bValidasiModalRef.value.show();
    };
    const loadingp3bValidasi = ref(false);
    const confirmP3bValidasiDialog = async (bvModalEvt) => {
      let fd = { ...formDatasP3BValidasi.value };
      fd.sk_tim_id = formDatas.value.sk_tim_id;
      loadingp3bValidasi.value = true;
      bvModalEvt.preventDefault();
      await context.refs.rulesValP3B.validate().then(success => {
        if (success) {
          skTim.validasiP3b(g, fd).then(resp => {
            if (resp.success) {
              getData();
              showNotifikasi(g, 'success', 'Success', resp.message)
              context.emit('changeStateEvent', 'detail');
              loadingp3bValidasi.value = false;

            } else {
              loadingp3bValidasi.value = false;
              showNotifikasi(g, 'danger', 'Error', resp.message)
            }
          }).catch(err => {
            console.log(err)
            loadingp3bValidasi.value = false;
          });
          nextTick();
          context.refs.p3bValidasiModalRef.toggle('#toggle-btn');
        }
      });
    };

    const formDatasKepalaValidasi = ref({
      username: g.$cookies.get("username"),
      is_validasi: null,
      catatan: null
    });
    const kepalaValidasiModalRef = ref(null);
    const openKepalaValidasiDialog = () => {
      kepalaValidasiModalRef.value.show();
    };
    const loadingKepalaValidasi = ref(false);
    const confirmKepalaValidasiDialog = async (bvModalEvt) => {
      let fd = { ...formDatasKepalaValidasi.value };
      fd.sk_tim_id = formDatas.value.sk_tim_id;
      loadingKepalaValidasi.value = true;
      bvModalEvt.preventDefault();
      await context.refs.rulesValKepala.validate().then(success => {
        if (success) {
          skTim.validasiKepala(g, fd).then(resp => {
            if (resp.success) {
              getData();
              showNotifikasi(g, 'success', 'Success', resp.message)
              context.emit('changeStateEvent', 'detail');
              loadingKepalaValidasi.value = false;
            } else {
              showNotifikasi(g, 'danger', 'Error', resp.message)
              loadingKepalaValidasi.value = false;
            }
          }).catch(err => {
            console.log(err)
            loadingKepalaValidasi.value = false;
          });
          nextTick();
          context.refs.kepalaValidasiModalRef.toggle('#toggle-btn');
        }
      });

    };

    /* Download Upload Dokumen SK Tim */
    const uploadDokumenSkTimModalRef = ref(null);
    const openUploadDokumenSkTimDialog = () => {
      uploadDokumenSkTimModalRef.value.show();
    };
    const uploadedFileSkTim = ref(null);
    const handleFileChange = (event) => {
      formDatasDokumenSkTim.value.file_sk_tim = null;
      const fileInput = event.target;
      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileSize = fileInput.files[0].size / 1024 / 1024; // in MB
        const maxFileSize = 2; // 2 MB
        const allowedFileType = 'application/pdf';

        if (file.type !== allowedFileType) {
          showNotifikasi(g, 'warning', 'Warning', `File yang diupload harus berformat PDF`);
          uploadedFileSkTim.value = null;
          fileInput.value = '';
        } else if (fileSize > maxFileSize) {
          showNotifikasi(g, 'warning', 'Warning', `File yang diupload maksimal ${maxFileSize} Mb`);
          uploadedFileSkTim.value = null;
          fileInput.value = '';
        } else {
          formDatasDokumenSkTim.value.file_sk_tim = file;
        }
      }
    }
    const formDatasDokumenSkTim = ref({});
    const loadingSubmitDokumenSKTim = ref(false);
    const confirmSubmitDokumenSkTim = (bvModalEvt) => {
      bvModalEvt.preventDefault();
      context.refs.modalUploadDokumenSkTimRules.validate().then(success => {
        if (success) {
          const fd = new FormData()
          fd.append('username', g.$cookies.get('username'))
          fd.append('tahun', props.parentFilter.tahun)
          fd.append('kolok', props.parentFilter.kolok)
          fd.append('file', formDatasDokumenSkTim.value.file_sk_tim)
          loadingSubmitDokumenSKTim.value = true;
          skTim.uploadSkTim(g, fd).then(resp => {
            if (resp.success) {
              getData();
              showNotifikasi(g, 'success', 'Success', resp.message)
              nextTick();
              context.refs.uploadDokumenSkTimModalRef.toggle('#toggle-btn');
              formDatasDokumenSkTim.value.file_sk_tim = null;
              context.emit('changeStateEvent', 'detail');
              loadingSubmitDokumenSKTim.value = false;

            } else {
              showNotifikasi(g, 'danger', 'Error', resp.message)
              loadingSubmitDokumenSKTim.value = false;
            }
          }).catch(err => {
            console.log(err)
            loadingSubmitDokumenSKTim.value = false;
          });
        }
      });
    };



    const loadingCetak = ref(false);
    const cetakDokumenSkTim = () => {
      const linkToOpen = process.env.VUE_APP_URL_BACKEND + process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna-b/sk-tim/sk-tim?kolok=' + props.parentFilter.kolok; // Replace with your specific link
      window.open(linkToOpen, '_blank');
    }

    const downloadFileSkTim = (url) => {
      window.open(url, '_blank');
    }
    return {
      isLoadDetail,
      getData,
      formDatas,

      loadingp3bValidasi,
      openp3bValidasiDialog,
      p3bValidasiModalRef,
      formDatasP3BValidasi,
      confirmP3bValidasiDialog,

      loadingKepalaValidasi,
      openKepalaValidasiDialog,
      kepalaValidasiModalRef,
      formDatasKepalaValidasi,
      confirmKepalaValidasiDialog,

      loadingSubmitDokumenSKTim,
      uploadDokumenSkTimModalRef,
      openUploadDokumenSkTimDialog,
      confirmSubmitDokumenSkTim,

      formDatasDokumenSkTim,
      uploadedFileSkTim,
      loadingCetak,
      cetakDokumenSkTim,
      downloadFileSkTim,
      parserValue,
      handleFileChange
    };
  },
  computed: {
    headerSkTim() {
      if (this.formDatas.tipe_kolok == 'skpd') {
        return "Pengguna Barang";
      } else if (this.formDatas.tipe_kolok == 'ukpd') {
        return "Kuasa Pengguna Barang";
      } else if (this.formDatas.tipe_kolok == 'upb') {
        return "Sekolah";
      } else {
        return this.formDatas.tipe_kolok;
      }
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BModal,
  },
  watch: {
    parentFilter: {
      handler(newVal, oldVal) {
        this.getData();
      },
      deep: true
    },
  },
  methods: {
    changeStateEvent(event) {
      this.$emit('changeStateEvent', event);
    },
    badgeActionWf(action) {
      if (action == 'setuju') {
        return 'badge-light-success';
      } else {
        return 'badge-light-danger';
      }
    },
    lebelField(field) {
      if (field == 'ketua') {
        if (this.formDatas.tipe_kolok == 'skpd') {
          return "Kepala PD";
        } else if (this.formDatas.tipe_kolok == 'ukpd') {
          return "Kepala UKPD";
        } else if (this.formDatas.tipe_kolok == 'upb') {
          return "Kepala UPB";
        }
      } else if (field == 'sekretaris') {
        if (this.formDatas.tipe_kolok == 'skpd') {
          return "Pejabat Eselon IV";
        } else if (this.formDatas.tipe_kolok == 'ukpd') {
          return "Pejabat Eselon IV";
        } else if (this.formDatas.tipe_kolok == 'upb') {
          return "Kepala Tata Usaha";
        }
      } else if (field == 'sekretariat') {
        if (this.formDatas.tipe_kolok == 'skpd') {
          return "Pengurus Barang";
        } else if (this.formDatas.tipe_kolok == 'ukpd') {
          return "Pengurus Barang Pembantu";
        }
      } else if (field == 'anggota') {
        if (this.formDatas.tipe_kolok == 'skpd') {
          return "Unsur Pada Bidang PD";
        } else if (this.formDatas.tipe_kolok == 'ukpd') {
          return "Unsur Pada Bidang UKPD";
        } else if (this.formDatas.tipe_kolok == 'upb') {
          return "Pengurus Barang/Unsur Pelaksana UPB";
        }
      }
    },
    //
    updateCountdown() {
      const moment = require('moment')
      moment.locale('id');
      const targetDate = moment('2024-03-31 23:59:00');
      const duration = moment.duration(targetDate.diff(moment()));
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      const countdown = `${days} Hari, ${hours} Jam, ${minutes} Menit, ${seconds} Detik`;
      let showCountdown = true;
      this.countdown = countdown;
      this.targetDate = targetDate.format('dddd, DD MMMM YYYY HH:mm:ss');
      this.days = days;
      this.hours = hours;
      this.minutes = minutes;
      this.seconds = seconds;
      if (!targetDate.isAfter()) {
        this.stopCountdown();
        this.showCountdown = false
        this.canUpload = false
      }
    },
    stopCountdown() {
      clearInterval(this.intervalId);
      this.countdown = null;
    },

  },
  mounted() {
    this.updateCountdown();
    this.intervalId = setInterval(this.updateCountdown, 1000);
  },
  data() {
    return {
      imgUrl: require('@/assets/images/pages/forgot-password-v2.svg'),
      required,
      showCountdown: true,
      canUpload: true,
      targetDate: null,
      days: null,
      hours: null,
      minutes: null,
      seconds: null,
      countdown: null,
      intervalId: null,

    };
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
}
</script>
  